import { SpGuideBoxHandle } from './innisfree/SpGuideBoxHandle'
console.log('SpGuideBoxHandle', SpGuideBoxHandle)
/**
 * key : 'VUE_APP_COMPANY_ID'
 *  - router
 *    - model [一个页面可能存在多个COMPONENTS] 对应 SpComponent 组件 的 myName 属性 以及对应的 handle;
 */
export const HANDLE_ROUTER_LIST = {
  '777': {
    '/drainage/channelCode': {
      'guideSelelct': SpGuideBoxHandle
    }
  },
  '666': {
    '/drainage/channelCode': {
      'guideSelelct': SpGuideBoxHandle
    }
  }
}
